import React from 'react'
import { Button, Col, } from 'reactstrap'
import queryString from 'query-string'

export default function DeleteButton({ id, search, history }) {
  let qs = queryString.parse(search)
  qs.r = id
  qs.m = 'delete'
  const query = `?${queryString.stringify(qs)}`
  let {pathname} = history.location 
  let DAd = pathname.includes('/users/manage/district-admins')
  let UserS = pathname.includes('/users/manage/schools')
  let SAd = pathname.includes('users/manage/school-admins/')
  let UserT = pathname.includes('/users/manage/teachers')
  let UserC = pathname.includes('/users/manage/classes/')
  let UserSt = pathname.includes('/users/manage/students')
  
  return (
    <span className='delete-button mr-1'>
      {(!(DAd || UserS || SAd || UserT || UserC || UserSt )) && <Button style={{"height":"40px","width":"40px","borderRadius":"50%"}} onClick={() => history.push(query)}><span style={{"position":"relative","left":"-4px","top":"1px"}}><h5>-</h5></span></Button>}
     {(DAd || UserS || SAd || UserT || UserC || UserSt)  && <Button style={{"height":"33px" , "width":"65px","borderRadius": "150px"}} onClick={() => history.push(query)}><small><span style={{"marginLeft":"-3px"}}>Delete</span ></small></Button>}
    </span>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/InfoCard/DeleteButton.js